import logo from "../images/logo.png";
import { Button } from "~/components/ui/button.jsx";
import ContactRequestForm from "@/components/ContactRequestForm.jsx";
import DidNotFindWhatYouLookinFor from "@/components/DidNotFindWhatYouLookinFor.jsx";
import { Link, usePage } from "@inertiajs/react";
import { catalog_path, services_path, taxon_path } from "@/routes.js";
import information, { policy } from "../data/information";

export default function () {
  const { taxons } = usePage().props;

  return (
    <footer className="bg-white pt-16">
      <div className="mx-auto container px-4 sm:px-6 lg:px-0">
        <div className="lg:grid lg:grid-cols-2">
          <div className="border-b border-gray-100 py-8 lg:order-last lg:border-s lg:border-b-0 lg:py-16 lg:ps-16">
            <div className="mt-8 space-y-4 lg:mt-0">
              <span className="hidden h-1 w-10 rounded-sm bg-brand-red lg:block"></span>
              <DidNotFindWhatYouLookinFor />
            </div>
          </div>

          <div className="py-8 lg:py-16 lg:pe-16">
            <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div>
                <p className="font-medium text-gray-900">Услуги</p>

                <ul className="mt-6 space-y-4 text-sm">
                  <li>
                    <Link
                      href={services_path({ anchor: "fotozoni" })}
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      Фотозоны
                    </Link>
                  </li>

                  <li>
                    <Link
                      href={services_path({ anchor: "decor" })}
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      Изготовлеине декораций
                    </Link>
                  </li>

                  <li>
                    <Link
                      href={services_path({ anchor: "banners" })}
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      Печать баннеров и плакатов
                    </Link>
                  </li>

                  <li>
                    <Link
                      href={services_path({ anchor: "biznes" })}
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      Оформление вашего бизнеса
                    </Link>
                  </li>
                </ul>

                <p className="font-medium mt-8 text-gray-900">Контакты</p>

                <div
                  className="mt-6 space-y-4 text-sm text-gray-900"
                  itemScope
                  itemType="http://schema.org/Organization"
                >
                  <div itemProp="name">Красный Шар</div>
                  <div
                    itemProp="address"
                    itemScope
                    itemType="http://schema.org/PostalAddress"
                  >
                    
                    <div itemProp="streetAddress">Адрес:{" "} переулок Вузовский, 17</div>
                    <div itemProp="postalCode">660025</div>
                    <div itemProp="addressLocality">Красноярск</div>
                  </div>
                  <div>
                    <span itemProp="telephone">8-902-927-42-57</span>
                  </div>
                  <div>
                    <span itemProp="email">shararam24@inbox.ru</span>
                  </div>
                </div>
              </div>

              <div>
                <p className="font-medium text-gray-900">Каталог</p>

                <ul className="mt-6 space-y-4 text-sm">
                  {taxons.map((t) => {
                    return (
                      <li key={`footer-taxon-link-${t.id}`}>
                        <Link
                          href={taxon_path(t.permalink)}
                          className="text-gray-700 transition hover:opacity-75"
                        >
                          {t.pretty_name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div>
                <p className="font-medium text-gray-900">Информация</p>
                <ul className="mt-6 space-y-4 text-sm">
                  {information.map((item, i) => (
                    <li>
                      <Link
                        href={item.link}
                        className="text-gray-700 transition hover:opacity-75"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-8 border-t border-gray-100 pt-8">
              <ul className="flex flex-wrap gap-4 text-xs">
                {policy.map((item, i) => (
                  <li key={`policy-link0${i}`}>
                    <Link
                      href={item.link}
                      className="text-gray-500 transition hover:opacity-75"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <p className="mt-8 text-xs text-gray-500">
                &copy; 2025. Красный Шар. Все права защищены.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
